module.exports = "<button (click)=\"onClick()\" class=\"btn btn-sm btn-info\">Менеджер файлов</button>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-fmanager-btn/nv-fmanager-btn.component.html
// module id = ../../../../../src/app/components/nv-fmanager-btn/nv-fmanager-btn.component.html
// module chunks = 0